import { Component, ViewEncapsulation } from '@angular/core';

import { BaseComponent } from '../../../common/components/base.component';
import { MatDialogRef } from '@angular/material';

@Component({
    templateUrl: './upgrade.modal.component.html',
    styleUrls: ['./upgrade.modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class UpgradeModalComponent extends BaseComponent {

    constructor(private dialogRef: MatDialogRef<UpgradeModalComponent>,
                ) {
        super();
    }

    public close(): void {
        this.dialogRef.close();
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/upgrade.modal/upgrade.modal.component.ts